import React, { useMemo } from "react";
import dynamic from "next/dynamic";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function Media(props) {
	const fields = props.data?.fields;
	const sectionIndex = props.sectionIndex;

	const extraClass = props.extraClass ? props.extraClass : "";
	const alignImage = fields.alignImage || "center";

	if (fields.audioUrl) {
		const DynamicAudioPlayer = dynamic(() => import("./AudioPlayer"), {
			loading: () => <audio />,
			ssr: false,
		});
		return (
			<Row className="g-0">
				<Col>
					<DynamicAudioPlayer src={fields.audioUrl} />
				</Col>
			</Row>
		);
	} else if (fields?.vimeoId) {
		const DynamicVimeoPlayer = dynamic(() => import("./VimeoPlayer"), {
			loading: () => <div />,
			ssr: false,
		});
		const vm = useMemo(
			() => (
				<Row className="g-0 VimeoPlayer ">
					<DynamicVimeoPlayer fields={fields} vimeoId={fields.vimeoId} />
				</Row>
			),
			[fields.vimeoId]
		);
		return vm;
	} else if (fields?.pathOrUrl) {
		const DynamicImage = dynamic(() => import("./Image"), {
			loading: () => <img />,
		});
		const DynamicLink = dynamic(() => import("./DynamicLink"), {
			loading: () => <a />,
		});
		//used here to signify a clickable link
		return (
			// <Row className="g-0 media-item-link">
			// 	<Col>
			<DynamicLink
				className={`d-flex align-items-start justify-content-${alignImage} ${extraClass}`}
				href={fields?.pathOrUrl}
				target="_blank"
			>
				<DynamicImage fields={fields} extraClass={` ${extraClass} `} {...props} />
			</DynamicLink>
			// 	</Col>
			// </Row>
		);
	} else {
		const DynamicImage = dynamic(() => import("./Image"), {
			loading: () => <img />,
		});
		return <DynamicImage fields={fields} extraClass={` ${extraClass} `} {...props} />;
	}
}
